import { toPercent } from "./commonUtils";
import { shortMonthsNames } from "./constants/periodLists";

export interface IRevenueMetricsByMonth {
  property_id: string;
  year: number;
  month: number;
  revenue: number;
  market_or: number;
  occupancy_rate: number;
  start_date: number;
  Revenue: number;
  occupancy_rate_guest: number;
  occupancy_rate_portal: number;
  occupancy_rate_direct: number;
  occupancy_rate_ical: number;


}

export interface IMappedRevenueMetricsByMonth
  extends Omit<IRevenueMetricsByMonth, "year"> {}

export const mapDataForRevenueMetrics = (data: IRevenueMetricsByMonth[]) =>
  data.reduce(
    (
      acc: { [key: string]: IMappedRevenueMetricsByMonth[] },
      { year, month, revenue, property_id, market_or, occupancy_rate, start_date, Revenue, occupancy_rate_guest, occupancy_rate_portal, occupancy_rate_direct, occupancy_rate_ical }
    ) => {
      const stringYear = String(year);
      if (!acc[stringYear]) acc[stringYear] = [];

      acc[stringYear] = [
        ...acc[stringYear],
        {
          month,
          revenue,
          property_id,
          market_or,
          start_date,
          Revenue,
          occupancy_rate,
          occupancy_rate_guest,
          occupancy_rate_portal,
          occupancy_rate_direct,
          occupancy_rate_ical,
        },
      ];

      return acc;
    },
    {}
  );

const getDataByYears = ({
  data,
  yearFrom,
  yearTo,
}: {
  data: { [key: string]: IMappedRevenueMetricsByMonth[] };
  yearFrom: string;
  yearTo: string;
}) => ({
  toData: data[yearTo],
  fromData: data[yearFrom],
});

export const getDisplayDataForRevenueMetrics = ({
  data,
  toYear,
  fromYear,
}: {
  data: { [key: string]: IMappedRevenueMetricsByMonth[] };
  toYear: string;
  fromYear: string;
}) => {
  const { toData, fromData } = getDataByYears({
    data,
    yearFrom: fromYear,
    yearTo: toYear,
  });

  return shortMonthsNames.map((month) => {
    const toMonth = toData?.find(
      (item) => item.month === shortMonthsNames.indexOf(month) + 1
    );
    const fromMonth = fromData?.find(
      (item) => item.month === shortMonthsNames.indexOf(month) + 1
    );

    return {
      name: month,
      [toYear]: toMonth ? toMonth.revenue : 0,
      [fromYear]: fromMonth ? fromMonth.revenue : 0,
    };
  });
};

export const getYearlyMarketOccupancyRateByMonth = ({
  data,
  yearFrom,
  yearTo,
}: {
  data: { [key: string]: IMappedRevenueMetricsByMonth[] };
  yearFrom: string;
  yearTo: string;
}) => {
  const { toData, fromData } = getDataByYears({
    data,
    yearFrom,
    yearTo,
  });

  return shortMonthsNames.map((month, index) => {
    const toDataItem = toData?.find((el) => el.month === index + 1);
    const fromDataItem = fromData?.find((el) => el.month === index + 1);

    return {
      name: month,
      [yearTo]: toPercent(toDataItem?.occupancy_rate ?? 0),
      [yearFrom]: toPercent(fromDataItem?.occupancy_rate ?? 0),
      market: toPercent(toDataItem?.market_or ?? 0),
      marketLastYear: toPercent(fromDataItem?.market_or ?? 0),
    };
  });
};

export const getYearlyMarketOccupancyRateByMonthNew = ({
  data,
  yearFrom,
  yearTo,  
}: {
  data: { [key: string]: IMappedRevenueMetricsByMonth[] };
  yearFrom: string;
  yearTo: string;  
}) => {
  const { toData, fromData } = getDataByYears({
    data,
    yearFrom,
    yearTo,    
  });

  return shortMonthsNames.map((month, index) => {
    const toItem = toData?.find((el) => el.month === index + 1);
    const fromItem = fromData?.find((el) => el.month === index + 1);   

    // occupancy types
    const occupancyKeys = [
      "occupancy_rate_guest",
      "occupancy_rate_portal",
      "occupancy_rate_direct",
      "occupancy_rate_ical",
    ] as const;

    const item: any = { name: month, market: toPercent(toItem?.market_or ?? 0), marketLastYear: toPercent(fromItem?.market_or ?? 0) };

    occupancyKeys.forEach((key) => {
      // flat keys for each year
      item[`${yearTo}_${key}`] = toPercent(toItem?.[key] ?? 0);
      item[`${yearFrom}_${key}`] = toPercent(fromItem?.[key] ?? 0);
    });

    return item;
  });
};


